import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './mobileQuoteInternal-hashed.scss';
import templateStr from 'text!./mobileQuoteInternal.html';

function controller() {
    var $ctrl = this;
    $ctrl.toggleCoverageStateVisibility = toggleCoverageStateVisibility;
}

function toggleCoverageStateVisibility(coverageState) {
    coverageState.infoVisible = !coverageState.infoVisible;
}

export default {
    restrict: 'E',
    transclude: true,
    bindings: {
        coverages: '<',
        branchCode: '&',
        offeringId: '<',
        id: '@'
    },
    template: cssUtil.hashTemplate(templateStr, styles),
    controller: controller
};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/directives/CommonOfferingSelection/mobileQuoteView/mobileQuoteInternal/mobileQuoteInternal.js
// module id = 850
// module chunks = 0